import type { PropsWithChildren } from 'react'
import { Popover as PopoverUDS } from '@sunwebgroup/ui-components/uds'

interface DropdownMultiselectPopoverContentProps {
  closeText: string
  title: string
}

export function Popover({ closeText, title, children }: PropsWithChildren<DropdownMultiselectPopoverContentProps>) {
  return (
    <PopoverUDS.Content closeText={closeText} title={title} hasPadding={false}>
      {children}
    </PopoverUDS.Content>
  )
}
